<template>
  <Container type="card-full" v-loading="loading">
    <div slot="header">
      <el-button @click="addOrEdit" type="primary" :loading="btnLoading">保存</el-button>
      <el-button @click="addOrEdit('submit')" type="primary" :loading="btnLoading">保存并下达</el-button>
    </div>
    <div>
      <div class="main">
        <el-form :model="demandrecModel" ref="ruleForm" label-position="right" class="mainfrom">
          <div class="from_label_big">
            <div>
              <div class="from_input">
                <el-form-item class="from-value" label="采购人">
                  <el-input v-model="demandrecModel.comfullname" disabled style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item class="from-value" label="需求名称" prop="demandname"
                  :rules="[{ required: true, message: '请输入需求名称', trigger: 'change' }]">
                  <el-input v-model="demandrecModel.demandname" style="width: 360px;"></el-input>
                </el-form-item>
                <el-form-item label="采购类别" prop="demandtype" :rules="[{ required: true, message: '请选择采购类别', trigger: 'change' }]">
                  <el-select v-model="demandrecModel.demandtype" placeholder="请选择采购类别" clearable>
                    <el-option label="货物" value="1"></el-option>
                    <el-option label="服务" value="2"></el-option>
                    <el-option label="设备" value="3"></el-option>
                    <el-option label="货物（设备）" value="4"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="需求编号" prop="demandcode" :rules="[{ required: true, message: '请输入需求编号', trigger: 'blur' }, { validator: validateCode, trigger: 'blur' }]">
                  <el-input v-model="demandrecModel.demandcode"></el-input>
                </el-form-item>
                <el-form-item label="预算价格（元）" prop="demandbudgetamt"
                  :rules="[{ required: true, message: '请输入预算价格', trigger: 'blur' }, { validator: validateAmt, trigger: 'blur' }]">
                  <el-input v-model="demandrecModel.demandbudgetamt" :maxlength="9"
                    @blur="inputMoney($event, 'demandbudgetamt')"></el-input>
                  <amount :money="String(demandrecModel.demandbudgetamt)" v-if="demandrecModel.demandbudgetamt" />
                </el-form-item>
              </div>
            </div>

            <div class="content">
              <el-form-item label="需求描述">
                <!--t-->
                <el-input show-word-limit :maxlength="255" type="textarea" :rows="5"
                  v-model.trim="demandrecModel.demanddescribe"></el-input>
              </el-form-item>
            </div>
            <el-form-item label="需求文件"
              v-if="+$store.getters.loginUser.comtype === 1 || +$store.getters.loginUser.comtype === 2">
              <!--<upload-file-more :fileList="fileList" :isUplaodFlag="type === 3 ? 0 : 1" folderName="project"-->
              <!--@changed='setfile' text="选择文件"></upload-file-more>-->
              <div class="file">
                <div class="uploadbtn">
                  <upload-btn @changed="setfile" text="上传附件"></upload-btn>
                </div>
                <div v-if="appendList.length" class="filelist" style="width: 100%;">
                  <div v-for="(item, index) in appendList" :key="index" class="fileitem">
                    <div class="linkstyle" @click="downFile(item.appendurl)">
                      <a :src="uploadAddr + item.appendurl">{{ item.appendfilename | toolongOmitted }}</a>
                    </div>
                    <div class="btn" @click="delappend(item)">
                      <span>删除</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </Container>
</template>

<script>
import request from '@/utils/request'
import utils from '../../assets/js/utils'
import uploadBtn from '../common/uploadBtn'
import common from '@/mixin/common'
import dayjs from 'dayjs'
import amount from '../common/amount'
let validateAmt = (rule, value, callback) => {
  if (!value || value.trim() === '') {
    return callback(new Error('预算金额不能为空'));
  }
  callback()
}
export default {
  name: 'demandrecAddOrEdit',
  mixins: [common],
  data() {
    return {
      id: this.$route.query.id,
      demandrecModel: {
      },
      appendList: [],
      btnLoading: false,
      loading: false,
      user: this.$store.getters.loginUser,
    }
  },
  components: { uploadBtn, amount },
  filters: {},
  created() { },
  deactivated() { },
  mounted() { },
  async activated() {
    if (this.$route.query.id) await this.getDetailById()
    if (!this.demandrecModel.comfullname) {
      this.$set(this.demandrecModel, 'comfullname', this.user.comfullname)
    }
  },
  methods: {
    validateAmt(rule, value, callback) {
      if (!value || value.trim() === '') {
        return callback(new Error('预算价格不能为空'))
      }
      if (isNaN(utils.delcommafy(value))) {
        return callback(new Error('预算价格必须为数字'))
      }
      if (+value <= 0) {
        return callback(new Error('预算价格必须大于0'))
      }
      callback()
    },
    validateCode (rule, value, callback) {
      return new Promise(async (resolve, reject) => {
        let  data  = await request({
          url: '/xtgl/demandrec/getDemandByCode',
          method: 'get',
          params: { demandcode: value.trim(), demandcomid: this.user.comid, demandid: this.$route.query.id},
        })
        if (data.length > 0) {
          reject('需求编号已存在')
        }
        resolve()
      })
      
    },
    async getDemandByCode ({demandcode}) {
      let { data } = await request({
        url: '/xtgl/demandrec/getDetailById',
        method: 'get',
        params: { demandcode, demandcomid: this.user.comid },
      })
      return data
    },
    async getDetailById() {
      this.loading = true
      let { list = [], appendList = [] } = await request({
        url: '/xtgl/demandrec/getDetailById',
        method: 'get',
        params: { demandid: this.$route.query.id },
      })
      this.demandrecModel = list[0]
      if (!this.demandrecModel.comfullname) {
        this.$set(this.demandrecModel, 'comfullname', this.user.comfullname)
      }
      if (Number(this.demandrecModel.demandbudgetamt)) {
        let val = utils.delcommafy(this.demandrecModel.demandbudgetamt)
        let reg = /^[0-9]+.?[0-9]*$/
        if (reg.test(val)) {
          this.demandrecModel.demandbudgetamt = utils.getDelcommafyValue(val)
        }
      }

      this.appendList = appendList
      this.loading = false
    },
    async setfile(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: 0,
        appendfromtype: 98,
        appendtype: '98',
        appendseq: this.appendList.length + 1,
        appendfilecode: '',
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ''),
      }
      this.appendList.push(append)
    },
    async addOrEdit(type = '') {
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          this.demandrecModel.demandid = this.$route.query.id
          this.demandrecModel.userid = this.$store.getters.loginUser.userid
          this.demandrecModel.demandcomid = this.$store.getters.loginUser.usercomid
          this.demandrecModel.cosid = this.$store.getters.loginUser.cosid
          this.demandrecModel.appends = this.appendList
          if (!!this.demandrecModel.demandbudgetamt) {
            console.log(this.demandrecModel.demandbudgetamt)
            this.demandrecModel.demandbudgetamt = utils.delcommafy(this.demandrecModel.demandbudgetamt + '')
          }

          let data = await request({
            url: '/xtgl/demandrec/addOrEdit',
            method: 'post',
            data: { ...this.demandrecModel },
          })
          if (data.issuccess === 1) {
            let { data: val } = data
            let id = val.id
            this.$refs['ruleForm'].resetFields()
            if (type === 'submit') {
              await request({
                url: '/xtgl/demandrec/changeStatus',
                method: 'post',
                data: { userid: this.$store.getters.loginUser.userid, demandid: id, demandstatus: 1 },
              })
            }
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    close() {
      this.$store.commit('close_tab', {
        routeName: this.$route.name,
        vm: this,
        newRouteName: 'demandrcList',
      })
    },
    inputMoney(el, name) {
      let val = utils.delcommafy(el.target.value)
      let reg = /^[0-9]+.?[0-9]*$/
      if (reg.test(val)) {
        this.demandrecModel[name] = utils.getInputValue(el)
      }
    },
    delappend(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, '提示', {
        type: 'warning',
      })
        .then(() => {
          let index = this.appendList.findIndex((val) => val.appendfilename === file.appendfilename)
          this.appendList.splice(index, 1)
        })
        .catch(() => { })
    },
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr
    },
  },
  watch: {
    async $route() {
      this.demandrecModel = {}
      this.appendList = []
      // if (this.id) await this.getDetailById()
    },
  },
}
</script>

<style lang="scss">
.projectNameInput {
  .el-input__suffix {
    right: -50px !important;
  }
}
</style>
<style lang="scss" scoped>
@import '../../styles/filelist';

.main {

  .from_input .el-input,
  .el-input .el-input__inner,
  .el-select {
    width: 200px;
  }

  .content-title {
    display: flex;

    .el-input {
      width: 525px;
    }

    .el-cascader {
      width: 200px;
    }
  }

  .content .el-textarea__inner,
  .el-textarea,
  .el-input {
    width: 860px;
  }

  .el-checkbox:last-of-type {
    margin-left: 0px;
  }

  .file {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    // width: 50%;
    .uploadbtn {
      display: flex;

      span {
        padding-left: 10px;
        color: red;
      }
    }
  }

  .supplynums {
    display: flex;
    font-size: 12px;
    line-height: 15px;
    flex-direction: column;
  }

  .checkbox_w {
    width: 45px;
  }
}

.mainfrom .el-input {
  line-height: 0;
}
</style>
